import React from "react";

import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBNavbarToggler,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBIcon,
  MDBBtn,
} from "mdbreact";
import { BrowserRouter as Router } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { Authcontext } from "../../context/Authcontext";
import { Link } from "react-router-dom";
import CreateBooksList from "../CreateBooksList";
const Navbar = () => {
  const { signin, signout, User } = useContext(Authcontext);
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setmodal] = useState(false);

  const toggleCollapse = () => {
    if (isOpen == false) {
      setIsOpen(true);
    } else if (isOpen == true) {
      setIsOpen(false);
    }
  };

  const toggle = () => {
    setmodal(!modal);
  };

  return (
    <MDBNavbar className="navbar" light expand="md">
      <MDBNavbarBrand className="white-text" center>
        <strong>
          <Link to={"/"} style={{ color: "white" }}>
            BOOKSHELF
          </Link>{" "}
        </strong>
      </MDBNavbarBrand>
      <MDBNavbarToggler onClick={toggleCollapse} />
      <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
        <MDBNavbarNav left>
          {User != null ? (
            <MDBNavItem color="black">
              <MDBDropdown>
                <MDBDropdownToggle className="white-text" nav caret>
                  <div className="d-md-inline white-text" color="black">
                    {" "}
                    Sort
                  </div>
                </MDBDropdownToggle>
                <MDBDropdownMenu className="dropdown-default">
                  <MDBDropdownItem>
                    {" "}
                    <Link to={`/show`}>All Books</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                    {" "}
                    <Link to={`/sort/read`}>Read</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                    <Link to={`/sort/unread`}>Unread</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                    <Link to={`/sort/lent`}>Lent</Link>
                  </MDBDropdownItem>
                  <MDBDropdownItem>
                    {" "}
                    <Link to={`/sort/unlent`}>Unlent</Link>
                  </MDBDropdownItem>
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem>
          ) : null}
        </MDBNavbarNav>
        <MDBNavbarNav right>
          {User != null ? (
            <MDBNavItem>
              <MDBBtn
                size="sm"
                rounded
                outline
                color="white"
                light
                onClick={toggle}
              >
                Add Book
              </MDBBtn>
              {modal ? <CreateBooksList toggle={toggle} modal={modal} /> : null}
            </MDBNavItem>
          ) : null}

          <MDBNavItem>
            {User == null ? (
              <MDBBtn
                size="sm"
                rounded
                outline
                color="white"
                light
                onClick={signin}
              >
                Sign in
              </MDBBtn>
            ) : (
              <MDBBtn
                size="sm"
                rounded
                outline
                color="white"
                light
                onClick={signout}
              >
                Sign out
              </MDBBtn>
            )}
          </MDBNavItem>
        </MDBNavbarNav>
      </MDBCollapse>
    </MDBNavbar>
  );
};
export default Navbar;
